import React, { Component } from 'react';
import { noop } from 'utils/helpers';

import './TextareaInput.scss';

export const getValueAttr = (value, defaultValue = '') => ({
  value: value !== undefined && value || defaultValue,
});

class TextareaInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: false,
    };
  }

  onBlur(evt) {
    const { label, onBlur: parentOnBlur = noop, required = false } = this.props;
    if (required) {
      const error = evt.target.value.trim().length ? false : `${label} is required`;
      this.setState({ errorMsg: error });
    }
    parentOnBlur(evt);
  }

  onFocus(evt) {
    const { onFocus: parentOnFocus = noop } = this.props;
    this.setState({ errorMsg: false });
    parentOnFocus(evt);
  }

  render() {
    const {
      name,
      label,
      className = '',
      placeholder = '',
      rows = 3,
      onChange = noop,
      required,
      value,
      defaultValue,
      errorMsg = false,
    } = this.props;

    return (
      <div className={`mercury-textareainput ${className}`.trim()}>
        {label && <label>{label}</label>}
        <textarea name={name} placeholder={placeholder} rows={rows} {...getValueAttr(value, defaultValue)} onChange={onChange} onFocus={evt => this.onFocus(evt)} onBlur={evt => this.onBlur(evt)} aria-label={label || name} required={!!required} />
        {(errorMsg || this.state.errorMsg)
        && <div className="mercury-textareainput-error">{errorMsg || this.state.errorMsg}</div>
        }
      </div>
    );
  }
}

export default TextareaInput;
